import logoUrl from '@/assets/Wave_logo_2.png';

const SIZES = { sm: 20, md: 26, lg: 38 } as const;

type Props = {
    size?: keyof typeof SIZES;
    /** Invert to white for dark surfaces. */
    knockout?: boolean;
    className?: string;
};

/** The wave.me "W" mark (Wave_logo_2.png). */
const WaveLogo = ({ size = 'md', knockout = false, className }: Props) => (
    <img
        src={logoUrl}
        alt="wave.me"
        style={{ height: SIZES[size], width: 'auto', ...(knockout ? { filter: 'invert(1)' } : {}) }}
        className={className}
    />
);

export default WaveLogo;
